<template>
  <v-card
    max-width="500"
    class="mx-auto pa-0"
    :loading="loading"
    :disabled="loading"
  >
    <v-toolbar color="warning">
      <v-toolbar-title>
        <h1>{{ $t("request_password.title") }}</h1>
      </v-toolbar-title>
    </v-toolbar>

    <v-container class="pa-0 pa-sm-3 pa-xl-6" fluid>
      <v-card class="mx-auto" color="grey-lighten-4">
        <v-card-text>
          <p class="text-center" v-if="validSecureKey">
            {{ $t("request_password.text2") }}
          </p>
          <p class="text-center" v-else>{{ $t("request_password.text") }}</p>
        </v-card-text>

        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent=""
          v-if="validSecureKey"
        >
          <v-card-text>
            <v-text-field
              label="New Password"
              v-model="password"
              type="password"
              :rules="passwordRules"
              required
            ></v-text-field
            ><v-text-field
              label="Confirm New Password"
              v-model="passwordConfirm"
              type="password"
              :rules="passwordConfirmRules"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mx-auto mb-3"
              type="submit"
              color="primary"
              variant="flat"
              elevation="2"
              :disabled="!valid"
              @click="setPassword"
            >
              {{ $t("request_password.button2") }}
            </v-btn>
          </v-card-actions>
        </v-form>

        <v-form ref="form" v-model="valid" @submit.prevent="" v-else>
          <v-card-text>
            <v-text-field
              label="Register/Apply ID"
              v-model="registerID"
              type="text"
              :rules="registerIDRules"
              required
            ></v-text-field>
            <v-text-field
              label="Citizen/Passport ID"
              v-model="citizenID"
              type="text"
              :rules="citizenIDRules"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mx-auto mb-3"
              type="submit"
              color="primary"
              variant="flat"
              elevation="2"
              :disabled="!valid"
              @click="requestPassword"
            >
              {{ $t("request_password.button") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
  </v-card>

  <v-dialog v-model="showModal" persistent eager max-width="750">
    <v-card>
      <v-card-text>
        <p>{{ modalMessage }}</p>
      </v-card-text>
      <v-card-actions class="pb-5 pr-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="outlined" to="/login">
          {{ $t("request_password.home_button") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserProvider from "@/services/user.provider.js";

const userProvider = new UserProvider();

export default {
  name: "RequestPassword",

  data: function () {
    return {
      loading: false,
      valid: false,
      showModal: false,
      modalMessage: "",

      registerID: "",
      registerIDRules: [
        (v) => !!v || "Register/Apply ID is required",
        (v) => /^\d+$/.test(v) || "Register/Apply ID must be valid",
      ],
      citizenID: "",
      citizenIDRules: [(v) => !!v || "Citizen/Passport ID is required"],

      validSecureKey: false,
      password: "",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 8 || "Password must be 8 or more characters.",
      ],
      passwordConfirm: "",
      passwordConfirmRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 8 || "Password must be 8 or more characters.",
        (v) => v === this.password || "Passwords don't match",
      ],
    };
  },

  computed: {
    secure_key() {
      return this.$route.query.secure_key ?? null;
    },
  },

  methods: {
    async requestPassword() {
      this.loading = true;

      const response = await userProvider
        .requestPassword(this.registerID, this.citizenID)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });

      if (response && response.email) {
        this.modalMessage = `ระบบได้ทำการส่งลิงก์สำหรับสร้างรหัสผ่านไปแล้วที่อีเมล: ${response.email} / System sent link for create new password to email: ${response.email}`;
        this.showModal = true;
      }

      this.loading = false;
    },

    async checkPassword() {
      const response = await userProvider
        .checkPassword(this.secure_key)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });

      if (response && response.status) this.validSecureKey = true;
      else {
        this.modalMessage = `ลิงก์ไม่สามารถใช้งานได้ กรุณาใช้ลิงก์ล่าสุด / The link cannot be used. Please use the most recently link`;
        this.showModal = true;
      }
    },

    async setPassword() {
      this.loading = true;

      const response = await userProvider
        .setPassword(this.secure_key, this.password)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });

      if (response && response.status) {
        this.modalMessage = `สร้างรหัสผ่านเรียบร้อยแล้ว / Password created successfully.`;
        this.showModal = true;
      }

      this.loading = false;
    },
  },

  created() {
    if (this.secure_key) this.checkPassword();
  },
};
</script>

<style lang="scss" scoped></style>
